import {ResourcesConfig} from 'aws-amplify';
import {config as API} from './api';
import {config as Auth} from './auth';

// Composed Amplify v6 config. GraphQL endpoint is read directly from
// VITE_API_ENDPOINT for AppSync. Add an explicit `API.GraphQL` block
// here if your app talks to multiple GraphQL endpoints.
export const config: ResourcesConfig = {
    Auth,
    API: {
        REST: API,
        GraphQL: {
            endpoint: import.meta.env.VITE_API_ENDPOINT ?? '',
            region: import.meta.env.VITE_AWS_REGION ?? 'us-west-2',
            defaultAuthMode: 'userPool',
        },
    },
};
